export default defineNuxtRouteMiddleware((to, _) => {
  if (import.meta.client && to) {
    useTrackEvent("page_view", {
      page_location: window.location.host + to.fullPath,
      page_path: to.path,
      page_title: document.title,
    });
  }
});
